// This file is not processed by babel
// Be aware to not include any syntax that
// might not be supported by any of the
// browser we need to support (including IE 11)

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./dist/core.esm')
} else {
  module.exports = require('./dist/core.cjs')
}
